module.exports = __webpack_public_path__ + "static/img/door-aside.fcac1097.png";